import { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import Typography from '../../../../../../../common/typography';
import { WithLoader } from '../../../../../../../common/loader';
import { IsMobileState } from '../../../../../../../hooks/useMobile';
import { PRIMARY_COLOR_HOVER } from '../../../../../../../../styles/themes';

interface StyleProps {
  isLoading: boolean;
  isMobile: IsMobileState;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: ({ isMobile }: StyleProps) => (isMobile ? '40px' : '48px'),
    height: ({ isMobile }: StyleProps) => (isMobile ? '40px' : '48px'),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.primary.main,
    borderRadius: '50px',
    '&:hover': {
      background: ({ isLoading }: StyleProps) => (isLoading ? theme.palette.primary.main : PRIMARY_COLOR_HOVER),
      cursor: ({ isLoading }: StyleProps) => (isLoading ? 'wait' : 'pointer')
    }
  }
}));

interface Props {
  userInitials: string | null;
  isLoading: boolean;
  isMobile: IsMobileState;
}

const UserAvatar = ({ userInitials, isLoading, isMobile }: Props) => {
  const classes = useStyles({ isLoading, isMobile });

  return (
    <Box className={classes.container} data-testid="header-user-avatar">
      <WithLoader size={24} color="white" loading={false}>
        <Typography size={isMobile ? 16 : 20} color="white">
          {userInitials}
        </Typography>
      </WithLoader>
    </Box>
  );
};

export default memo(UserAvatar);
